import React, { useEffect, useState } from 'react';
import {
    InAppMessagesRequestParams,
    getInAppMessages,
    initializeWithConfig,
} from '@iterable/web-sdk';
import { getWebIterableToken } from 'common/api/crm/family/service';
import { useLocation } from 'react-router-dom';
import { useRootSelector } from 'rootStore';
import { IS_FLIPGIVE } from 'common/env';

const tokenFetch = async ({ userID: _userID }: { userID?: any }) => {
    return (await getWebIterableToken()) as string;
};

const PACKAGE_NAME =
    (IS_FLIPGIVE
        ? process.env.REACT_APP_ITERABLE_WEB_PACKAGE_NAME_FLIPGIVE
        : process.env.REACT_APP_ITERABLE_WEB_PACKAGE_NAME) || '';

const initializeIterableSDK = () => {
    return initializeWithConfig({
        authToken:
            (IS_FLIPGIVE
                ? process.env.REACT_APP_ITERABLE_API_KEY_FLIPGIVE
                : process.env.REACT_APP_ITERABLE_API_KEY) || '',
        configOptions: {
            isEuIterableService: false, // Set based on your service region
            dangerouslyAllowJsPopups: true, // Enable JavaScript execution
        },
        generateJWT: tokenFetch,
    });
};

export const IterableInBrowserMessaging = () => {
    const userId = useRootSelector((r) => r.store.home.homeDetails?.profile?.userId);
    const location = useLocation();
    const [userIsSet, setUserIsSet] = useState(false);
    const [iterableSDK, setIterableSDK] = useState<any>(null);

    useEffect(() => {
        try {
            const sdk = initializeIterableSDK();
            setIterableSDK(sdk);
        } catch (error: any) {
            console.error('[Iterable] Failed to initialize SDK:', error);
        }
    }, []);

    const {
        request,
        pauseMessageStream: _pauseMessageStream,
        resumeMessageStream: _resumeMessageStream,
        triggerDisplayMessages: _triggerDisplayMessages,
    } = getInAppMessages(
        {
            // Here, configure the SDK. For more information, check out the
            // web SDK's GitHub repository: https://github.com/iterable/iterable-web-sdk
            bottomOffset: '20px',
            count: 20,
            closeButton: {
                iconPath: '/media/close.svg',
                // color: colors.paleBlue,
                position: 'top-right',
                sideOffset: '25px',
                size: '80px',
                topOffset: '10px',
            },
            displayInterval: 1000,
            onOpenNodeToTakeFocus: 'input',
            onOpenScreenReaderMessage: '...',
            packageName: PACKAGE_NAME,
            rightOffset: '20px',
            topOffset: '20px',
            // Note: JavaScript execution is now configured during SDK initialization
            // with dangerouslyAllowJsPopups in the configOptions
        } as InAppMessagesRequestParams,
        { display: 'immediate' } as any
    );

    useEffect(() => {
        if (!iterableSDK) {
            return; // Wait for SDK to be initialized
        }

        if (!userId) {
            if (userIsSet) {
                try {
                    setUserIsSet(false);
                    iterableSDK.logout();
                } catch (e) {
                    console.error(e);
                }
            }
            return;
        }

        iterableSDK
            .setUserID(userId)
            .catch()
            .then(() => {
                setUserIsSet(true);
                request().then().catch();
            });

        return () => {
            try {
                if (userIsSet) {
                    setUserIsSet(false);
                    iterableSDK.logout();
                }
            } catch (e: any) {
                console.error(e);
            }
        };
    }, [userId, iterableSDK]);

    useEffect(() => {
        if (userIsSet) {
            request().then().catch();
        }
    }, [location]);

    return null;
};
